<div class="page-wrapper" style="min-height: 347px;">
  <div class="content container-fluid ">
    <div class="bg-white page-border">
      <div class="row row-replace add-m-b">
        <div class="col-md-6 col-p h5">DASHBOARD / EMPLOYEE MASTER </div>
          <div class="col-md-6 top-corner-items col-p">
          </div>
        </div>
      <div class="row row-replace">
        <div class="col-md-6 d-flex padding-right-2 padding-left-2">
          <div class="card flex-fill add-mrf-card">
              <div class="card-body card-padding-bottom" *ngIf="sallaryStructure.length > 0">
                  <h3 class="card-title page-header0"><i class="fa fa-briefcase"></i>&nbsp;Salary</h3>
                  <hr />

                  <p>Cand ID</p>
                  <input type="number" [(ngModel)]="candID" class="form-control" />
                  <p>PF Type</p>
                  <select class="form-control"   [(ngModel)]="pfType"  (change)="getCandPayrollStructure()"  >
                      <option value="151">PF on Gross</option>
                      <option value="150">Normal PF</option>
                      <option value="157">PF on Capping (BAISC + DA) </option>
                  </select>
                  <p>5% Check</p>
                  <select class="form-control"   [(ngModel)]="percentageCheckValue"  (change)="changeFivePercent()"  >
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                  </select>

                  <!-- <pre>
                    {{sallaryStructure | json}}
                  </pre> -->
                  <div class="border-salary">
                      <h3 class="card-title page-header0 mt-15">Gross Salary <input type="number" (blur)="changeValueTotal($event,'0','')"   [(ngModel)]="grossTotal" class="form-control"  />
                        <button (click)="loadReset()" class="btn btn-sm btn-info"  > Reset </button>

                      </h3>
                      <hr />
                      <div class="row" *ngFor="let list of sallaryStructure; let i = index;">
                          <label *ngIf="list.is_gross == 1" class="col-form-label col-md-4 col-sm-4"> {{list.comp_name}} </label>
                          <div *ngIf="list.is_gross == 1" class="col-md-8 col-sm-8">
                              <input type="number" [disabled]="list.comp_id == 5 || list.comp_id == 21" [min]="min" (blur)="changeValueTotal($event,list.comp_id,i)"   class="form-control" placeholder="{{list.comp_name}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="list.comp_value" />
                          </div>
                      </div>

                  </div>

                  <div class="border-salary">
                      <h3 class="card-title page-header0 mt-15">Net Salary</h3>
                      <hr />
                      <div class="row" *ngFor="let list of sallaryStructure; let j = index;">
                          <label *ngIf="list.is_gross == 0" class="col-form-label col-md-4 col-sm-4"> {{list.comp_name}} </label>
                          <div *ngIf="list.is_gross == 0" class="col-md-8 col-sm-8">
                              <input type="number" [min]="min" (change)="changeValue($event,list,j)" (keyup)="changeValue($event,list,j)" [disabled]="list.comp_id == 22" class="form-control" placeholder="{{list.comp_name}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="list.comp_value" />
                          </div>
                      </div>
                  </div>




                </div>
              </div>
            </div>
            <div class="col-md-6  padding-right-2 padding-left-2">

              <!-- <h4>Gross total {{grossTotal}}</h4>
              <h4>BASIC {{basic}}</h4>
              <h4>DA {{da}}</h4>
              <h4>HRA {{hra}}</h4> -->
              <!-- <h4>HRA min {{hraMin}}</h4>
              <h4>HRA max {{hraMax}}</h4> -->
              <!-- <h4>Other Allowance {{otherAllowance}}</h4>
              <h4>Site Allowance {{siteAllowance}}</h4> -->
              <!-- <h4>finalTotal {{finalTotal}}</h4> -->

              <!-- <h4>BASIC Backup {{basicBackup}}</h4>
              <h4>DA Backup {{daBackup}}</h4>
              <h4>HRA Backup {{hraBackup}}</h4> -->
              <!-- <h4>Other Allowance Backup {{otherAllowanceBackup}}</h4>
              <h4>Site Allowance Backup {{siteAllowanceBackup}}</h4> -->
              <!-- <h4>finalTotalBackup {{finalTotalBackup}}</h4> -->
            </div>
       </div>
    </div>
  </div>
</div>








